import { useMutation } from "@apollo/client";
import {
    constantsData,
    identifiersData,
    namesData,
    statusTypesData,
} from "data";
import { deleteTerritoryMutation, getTerritoriesListQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useDeleteTerritory = (page, limit) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [deleteTerritoryAction, { loading }] = useMutation(
        deleteTerritoryMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getTerritoriesListQuery,
                    variables: {
                        limit,
                        orderBy: { name: "asc" },
                        page,
                        where: {},
                    },
                },
            ],
        },
    );

    const { deleteTerritoryPending: deleteTerritoryPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const deleteTerritory = async (id) => {
        try {
            await deleteTerritoryAction({
                onCompleted: () => {
                    dispatch(openAlert(
                        t(
                            "messages.deleteMsgs.success",
                            { entity: t("territories.entity") },
                        ),
                        statusTypesData.success,
                    ));
                },
                variables: {
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${deleteTerritoryPendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(
                    () => t(
                        "messages.deleteMsgs.pending",
                        { entity: t("territories.entity") },
                    ),
                    { toastId: `${deleteTerritoryPendingToastName}_${toastId}` },
                );
            }
        },
        [loading], //eslint-disable-line
    );

    return { deleteTerritory };
};

export default useDeleteTerritory;
